import { gql } from "@apollo/client";

export const SendContactEmailMutation = gql`
    mutation SendContactEmail($input: ContactEmailInput!) {
        SendContactEmail(input: $input) {
            message
        }
    }
`;